import { useCallback } from 'react'

import { useAccordionDispatch } from './AccordionContext'

export function useCollapseAccordion(accordion: string) {
  const dispatch = useAccordionDispatch()

  return useCallback(() => {
    dispatch({ type: 'collapse', payload: accordion })
  }, [accordion])
}
